'use client'
import { useEffect, useState } from 'react';
import { useAppDispatch } from '../store/store';
import { loadTokenFromStorage } from '../store/authSlice';

export default function AuthInitializer() {
  const dispatch = useAppDispatch();
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    // Load token from localStorage after hydration
    dispatch(loadTokenFromStorage());
    setIsHydrated(true);
  }, [dispatch]);

  // Prevent hydration mismatch by ensuring client-side rendering
  if (!isHydrated) {
    return null;
  }

  return null; // This component doesn't render anything
}
